import { Info } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";

// Icona "i" con testo d'aiuto: su mobile si apre/chiude al tap (il Tooltip
// hover-based lampeggiava e spariva), su desktop al click. Resta aperto finché
// non si tocca fuori.
export const InfoHint = ({ text, className = "", iconClass = "h-4 w-4", testid, label }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        data-testid={testid}
        aria-label={label || "Info"}
        onClick={(e) => e.stopPropagation()}
        className={`text-muted-foreground/50 transition-colors hover:text-muted-foreground ${className}`}
      >
        <Info className={iconClass} />
      </button>
    </PopoverTrigger>
    <PopoverContent
      side="top"
      align="end"
      onOpenAutoFocus={(e) => e.preventDefault()}
      className="w-auto max-w-[260px] p-3 text-xs font-normal normal-case leading-snug"
    >
      {text}
    </PopoverContent>
  </Popover>
);
